/**
 * Store для состояния UI
 */
import { create } from 'zustand'

type UIMode = 'scanner' | 'admin'

interface UIState {
  mode: UIMode
  isAdminMode: boolean
  
  setMode: (mode: UIMode) => void
  setAdminMode: (isAdmin: boolean) => void
}

export const useUIStore = create<UIState>((set) => ({
  mode: 'scanner',
  isAdminMode: false,
  
  setMode: (mode: UIMode) => set({ mode }),
  
  setAdminMode: (isAdmin: boolean) =>
    set({ isAdminMode: isAdmin, mode: isAdmin ? 'admin' : 'scanner' }),
}))

